/**
 * Generated by `npm run images` — do not edit.
 * Maps each artwork to its source file, intrinsic size and available WebP widths.
 */
export const artworkManifest = {
  "nexion": {
    "source": "nexion.png",
    "width": 1520,
    "height": 1520,
    "widths": [
      400,
      800,
      1200
    ]
  },
  "idle_archive": {
    "source": "idle_archive.png",
    "width": 2048,
    "height": 2048,
    "widths": [
      400,
      800,
      1200
    ]
  },
  "cosmic_synthesis": {
    "source": "cosmic_synthesis.jpeg",
    "width": 1024,
    "height": 1024,
    "widths": [
      400,
      800,
      1024
    ]
  },
  "shadow_node": {
    "source": "shadow_node.png",
    "width": 2048,
    "height": 2048,
    "widths": [
      400,
      800,
      1200
    ]
  },
  "sudoku_rush": {
    "source": "sudoku_rush.png",
    "width": 1024,
    "height": 1024,
    "widths": [
      400,
      800,
      1024
    ]
  },
  "eco_tycoon": {
    "source": "eco_tycoon.png",
    "width": 1024,
    "height": 1024,
    "widths": [
      400,
      800,
      1024
    ]
  },
  "power_idle": {
    "source": "power_idle.png",
    "width": 2048,
    "height": 2048,
    "widths": [
      400,
      800,
      1200
    ]
  },
  "neon_syntax": {
    "source": "neon_syntax.png",
    "width": 1672,
    "height": 941,
    "widths": [
      400,
      800,
      1200
    ]
  },
  "blog_helix_part1": {
    "source": "blog_helix_part1.png",
    "width": 1600,
    "height": 1000,
    "widths": [
      400,
      800,
      1200
    ]
  },
  "lab_mira": {
    "source": "lab_mira.png",
    "width": 1600,
    "height": 1000,
    "widths": [
      400,
      800,
      1200
    ]
  }
};
